﻿(function (angular) {
  "use strict";

  angular.module("Toyota").directive("tyGeoLocateSearch", function () {
    var controller = [
      "$scope",
      "$rootScope",
      "Location",
      "DealerSelector",
      "$element",
      function ($scope, $rootScope, Location, DealerSelector, $element) {
        $scope.init = function () {
          $scope.loading = false;
          $scope.$on("GeoPostCode", function (event, postcode) {
            $scope.geoPostCode = postcode;
          });

          $scope.geoPostCode = Location.get().postcode;
        };

        $scope.init();

        $scope.showHide = function () {
          // Open Modal
          DealerSelector.openDealerSelector();
          $rootScope.$broadcast("geo-locate-search-click", $element);
        };
      },
    ];

    return {
      scope: true,
      restrict: "A",
      controller: controller,
      bindToController: true,
    };
  });
})(window.angular);
